export default __webpack_public_path__ + "static/media/express.2e9f3166.png";